import { addTraits } from 'src/api';

export const getMessages = state => addTraits(state.messaging.messages);
